import React, { Component } from "react";
import "./MainJobTitle.css";
import MediaQuery from "react-responsive";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { withRouter } from "react-router-dom";

import * as actions from "../../../store/actions/index";
import Button from "../../UI/Button/Button";
import JoblistDropDown from "../../../components/UI/JobListDropDown/JobListDropDown";
import ReactGA from 'react-ga';
import config from '../../../config';
import dropdownButton from '../../../assets/images/job-dropdown.svg';
import Icon from '../../../components/UI/Icon/Icon';
import ConsoleLog from './../../../hoc/ConsoleLog/ConsoleLog';

/**
 * @desc MainJobTitle
 * @version 1.0
 * @author Kurt Jarchow
 */
const JobsListPopupItem = props => {
  const activeClass = props.currentJobId == props.job.job_id ? "active" : "";
  return (
    <li className={"job-title--list-item " + activeClass}>
      <a href="#" onClick={props.handleJobChange} data-value={props.job.job_id}>
        {props.job.job_name} - {props.job.job_bh_id}
      </a>
    </li>
  );
};

const JobsListPopup = props => {
  return (
    <ul className="job-title--list">
      {props.jobsList.map((job, index) => (
        <JobsListPopupItem
          key={index}
          job={job}
          handleJobChange={props.handleJobChange}
          currentJobId={props.currentJobId}
        />
      ))}
    </ul>
  );
};

class MainJobTitle extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      jobs: [],
      jobsAdded: false,
      showDropDown: false
    };
    this.tooltipJobTitles = React.createRef();
    this.handleJobChange = this.handleJobChange.bind(this);
  }

  handleClickOutside = props => {
    this.setState({ showDropDown: false });
  };
  handleJobChange(e) {
    e.preventDefault();
    // Coudn't get the .hide() method to work, updating state instead
    //this.tooltipJobTitles.current.state.show = false;
    const jobId = e.currentTarget.getAttribute("data-value");
    const job = this.state.jobs.find(job => job.job_id == jobId);
    const jobTitle = job.job_name;
    this.props.handleJobSelected(jobId);
    this.setState({ showDropDown: !this.state.showDropDown });
    /* The following is the React Google analytics code section start point */
    ReactGA.initialize(config.GAId);
    ReactGA.pageview("/job/" + jobTitle);
    //ConsoleLog("handleJobChange GA candidate list : ", "/job/" + jobTitle);
    /* React Google analytics code section end point */
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.jobTitle !== nextProps.jobTitle) {
      return true;
    }
    if (this.state.jobsAdded !== nextState.jobsAdded) {
      return true;
    }
    if (this.props.user_id !== nextProps.user_id) {
      return true;
    }
    if (this.state.showDropDown !== nextProps.showDropDown) {
      return true;
    }

    if (this.state.jobs !== nextState.jobs) {
      return true;
    }
    return false;
  }

  componentDidUpdate(nextProps) {
    ReactTooltip.rebuild();
    if (this.props.jobs !== nextProps.jobs) {
      this.setState({ jobs: this.props.jobs, jobsAdded: true });
      /* 
     The following is the React Google analytics code section start point
     */
      const jobTitle = this.props.jobTitle;
      ReactGA.initialize(config.GAId);
      ReactGA.pageview("/job/" + jobTitle);
      //ConsoleLog("componentDidUpdate GA candidate list : ", "/job/" + jobTitle);
      /* 
      React Google analytics code section end point
      */
    }
  }

  componentDidMount() {
    this.setState({ jobs: this.props.jobs, jobsAdded: true });
  }

  /**
   * @desc Actual rendering of the component
   * @param null
   * @return DOM element
   */
  render() {
    const jobsList = this.state.jobs;
    const titleClass = this.props.titleClass;
    const jobTitleId = this.props.jobTitleId;
    const currentJob = jobsList.find(job => job.job_id == jobTitleId);
    const jobBHId =
      jobsList.length > 0 && jobTitleId !== null && currentJob
        ? currentJob.job_bh_id
        : "";
    const jobTitle =
      this.props.jobTitle && jobBHId
        ? this.props.jobTitle + " - " + jobBHId
        : "Loading...";
    return (
      <React.Fragment>
        <div
          className={this.props.className}
        >
          {this.props.currentPage !== "report" ?
            <h1 className={titleClass}>
              {titleClass === "interview-title " ? "Interview " : "Candidate "}list for
            {titleClass === "interview-title " ? "" : <br />}
            </h1>
            : <Icon icon="left-arrow" className="report-back-icon " onClick={() => { this.props.history.goBack() }} />}
          <div className="job-title--jobtitle">
            <MediaQuery query="(min-device-width: 768px)">
              <span>{jobTitle}</span>
            </MediaQuery>
            <MediaQuery query="(max-device-width: 767px)">
              <span>
                <h1>{jobTitle}</h1>
              </span>
            </MediaQuery>
            {jobsList.length > 1 &&
              this.props.currentPage !== "review" ? /*&&
            urlArray[3] !== "candidate" ? */
              (
                <a
                  className="job-title--button ignore-react-onclickoutside"
                  data-for="jobTitles"
                  data-tip
                  data-event="click focus"
                >
                  <img
                    src={dropdownButton}
                    onClick={() => {
                      this.setState({ showDropDown: !this.state.showDropDown });
                    }} />
                </a>
              ) : (
                " "
              )}
          </div>

          <JoblistDropDown
            id="jobTitles"
            ref={this.tooltipJobTitles}
            items={
              <JobsListPopup
                jobsList={jobsList}
                handleJobChange={this.handleJobChange}
                currentJobId={jobTitleId}
              />
            }
            handleClickOutside={this.handleClickOutside}
            showDropDown={this.state.showDropDown}
          />
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  jobs: state.talentPool.jobList,
  jobTitleId: state.talentPool.jobTitleId,
  jobTitle: state.talentPool.jobTitle
});

const mapDispatchToProps = dispatch => {
  return {
    onSetJobTitles: (jobTitleId, jobTitle, jobBHID, companyType) =>
      dispatch(actions.setJobTitle(jobTitleId, jobTitle, jobBHID, companyType))
  };
};

const reduxConnector = connect(
  mapStateToProps,
  null,
  null,
  { pure: false }
);

export default withRouter(reduxConnector(MainJobTitle));



// WEBPACK FOOTER //
// ./src/components/Client/MainJobTitle/MainJobTitle.js